import { useState } from "react";
import { Images } from "lucide-react";
import { Pic } from "@/components/Pic";
import { thumbUrl } from "@/lib/images";
import { Lightbox } from "@/components/Lightbox";

const T = {
  de: { title: "Impressionen", more: "+{n} weitere", img: "Bild {i} von {t}" },
  en: { title: "Impressions", more: "+{n} more", img: "Image {i} of {t}" },
  es: { title: "Impresiones", more: "+{n} más", img: "Imagen {i} de {t}" },
  nl: { title: "Impressies", more: "+{n} meer", img: "Foto {i} van {t}" },
  pl: { title: "Wrażenia", more: "+{n} więcej", img: "Zdjęcie {i} z {t}" },
  fr: { title: "Impressions", more: "+{n} autres", img: "Image {i} sur {t}" },
  it: { title: "Impressioni", more: "+{n} altre", img: "Immagine {i} di {t}" },
};
const TILES = 5;

/** Bildergalerie der Inselseite (linke Spalte unter der Klimatabelle): Mosaik 1 groß + 4 klein, „+N weitere“, Klick öffnet die Lightbox. */
export const IslandGallery = ({ images = [], alts = [], name, lang }) => {
  const [view, setView] = useState(null);
  const tx = T[lang] || T.en;
  if (!images.length) return null;
  const altOf = (i) => { const a = alts.find((x) => x.url === images[i]) || {}; return (a[lang] || a.de || "").trim() || `${name} – ${tx.img.replace("{i}", i + 1).replace("{t}", images.length)}`; };
  const shown = images.slice(0, TILES);
  const rest = images.length - TILES;
  return (
    <section className="mt-10" data-testid="island-gallery">
      <h2 className="font-serif text-2xl mb-4 flex items-center gap-2"><Images className="w-5 h-5 text-brand" />{tx.title.replace("{n}", name)}</h2>
      <div className={`grid gap-2 ${shown.length === 1 ? "grid-cols-1" : "grid-cols-2 sm:grid-cols-4 sm:grid-rows-2"}`}>
        {shown.map((src, i) => {
          const last = i === TILES - 1 && rest > 0;
          return (
            <button key={src} type="button" onClick={() => setView(i)} aria-label={altOf(i)}
                    className={`group relative overflow-hidden rounded-xl bg-tint ${i === 0 && shown.length > 1 ? "col-span-2 row-span-2 aspect-[4/3] sm:aspect-auto" : "aspect-[4/3]"} ${shown.length === 1 ? "aspect-[16/9]" : ""}`}
                    data-testid={`island-gallery-tile-${i}`}>
              <Pic src={i === 0 ? src : thumbUrl(src)} alt={altOf(i)} className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" loading={i === 0 ? "eager" : "lazy"} />
              {last && <span className="absolute inset-0 flex items-center justify-center bg-black/45 text-white text-lg font-semibold" data-testid="island-gallery-more">{tx.more.replace("{n}", rest)}</span>}
            </button>
          );
        })}
      </div>
      {view !== null && <Lightbox images={images} start={view} alt={altOf} caption={altOf} onClose={() => setView(null)} />}
    </section>
  );
};
